export default "__VITE_ASSET__74770ac1__"